export default __webpack_public_path__ + "static/media/4.83a397e5.jpg";